import ShelfApi from "~/utils/ShelfApi.js"

export function updateSettings(tenantName, settings) {
  return dispatch => ShelfApi.put(`settings/${tenantName}`, settings)
}



// WEBPACK FOOTER //
// ./src/actions/settingsActions.js